module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"events_header":"Featured Events","more_info":"More Info"},"ja":{"events_header":"特集/イベント","more_info":"詳細をみる"}}')
  delete Component.options._Ctor
}
